<script setup>
import { onMounted, ref } from "vue";
import { store } from "@/store";
import { useRoute, useRouter } from "vue-router";
import useApi from "@/composables/useApi";
import ResultsMultiple from "@/views/Guest/QuickPayment/ResultsMultiple.vue";
const { service, invoice } = useApi();

const loading = ref(false);
const id = ref(0);
const route = useRoute();
const router = useRouter();
const serviceData = ref({});
const invoicesToPayData = ref([]);
const invoicesInProcess = ref([]);
const hasError = ref(false);

const serviceNumber = ref("");

// The id comes from the URL, so only accept services owned by the logged in
// customer: anyone could type the id of someone else's service
const loadService = async (service_id, partner_id) => {
  const data = await service.getServiceById(service_id, partner_id);
  const found = data.payload?.[0];
  const owner = Array.isArray(found?.partner_id)
    ? found.partner_id[0]
    : found?.partner_id;
  return found && owner === partner_id ? found : null;
};

const loadPaymentHistory = async (service_id) => {
  const data = await invoice.getPaymentHistoryInvoicesByService(service_id);
  return data;
};

const loadInvoices = async (service_id) => {
  const data = await invoice.listInvoicesByService(service_id);
  let result = data.payload.filter(invoice => ["not_paid", "partial"].includes(invoice.payment_state));
  const invoices_in_payment_history = await loadPaymentHistory(service_id);
  result.sort((a, b) => {
    // First sort by due date descending
    const dateCompare = new Date(b.invoice_date_due) - new Date(a.invoice_date_due);
    if (dateCompare !== 0) return dateCompare;
    // If dates are equal, sort by id ascending
    return a.id - b.id;
  });
  result = result.map(invoice => ({
    ...invoice,
    state_to_pay: true,
    payment_status: invoices_in_payment_history.includes(invoice.id) ? true : false
  }));
  // Facturas con un pago ya registrado en el historial: se muestran "en proceso" y no se pueden pagar de nuevo
  const inProcess = result
    .filter(invoice => invoice.payment_status)
    .map(invoice => ({ ...invoice, state_to_pay: false }));
  result = result.filter(invoice => !invoices_in_payment_history.includes(invoice.id));
  return { toPay: result, inProcess };
};

onMounted(async () => {
  store.APP_BACK_BUTTON = true;
  console.log("onMounted [QuickPayment]");
  try {
    id.value = Number(route.params.id);
    store.APP_LOADING = true;
    loading.value = true;
    const partnerId = store.user?.id;
    const ownService =
      Number.isInteger(id.value) && id.value > 0 && partnerId
        ? await loadService(id.value, partnerId)
        : null;
    if (!ownService) {
      router.replace({ name: "Home" });
      return;
    }
    serviceData.value = ownService;
    serviceNumber.value = serviceData.value.name;
    const { toPay, inProcess } = await loadInvoices(id.value);
    invoicesToPayData.value = toPay;
    invoicesInProcess.value = inProcess;
  } catch (error) {
    console.log(error);
  } finally {
    store.APP_LOADING = false;
    loading.value = false;
  }
});
</script>
<template lang="pug">
div
  //- pre {{ serviceData }}
  //- pre {{ invoicesToPayData }}
  ResultsMultiple(:key="0" :serviceNumber="serviceNumber" :hasError="hasError" v-model:invoices="invoicesToPayData" :invoicesInProcess="invoicesInProcess" :service="serviceData" :showOption="false")
</template>
